import { IconFilePencil, } from '@tabler/icons';

// constant
const icons = {
    IconFilePencil,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const languagePages = {
    id: 'Language management',
    title: 'Language management',
    caption: 'manage Language list',
    type: 'group',
    children: [
        {
            id: 'fetchIndustry',
            title: 'language',
            type: 'item',
            url: '/language/view',
            icon:icons.IconFilePencil
        }
    ],

};

export default languagePages;